export const fetchGet = async function(url,query,timeout) {
    let result = await fetch({
      url: url,
      method: "get",
      params: query,
      timeout:timeout,
      noFormat: true,
      responseType: "text"
    });
    let res = JSON.parse(result);
    return res;
}

export const fetchPost = async function(url,query,timeout) {
  let result = await fetch({
    url: url,
    method: "post",
    data: query,
    timeout:timeout,
    noFormat: true,
    responseType: "text"
  });
  let res = JSON.parse(result);
  return res;
}
export const fetchGetDown = async function(url,query,name) {
  let params=query
  delete params.pageNo
  delete params.pageSize
  let res = await fetch({
    url: url,
    method: "get",
    params,
    noFormat: true,
    responseType: "blob",
    timeout: 60000000 * 1000
  });
  let urlLink = window.URL.createObjectURL(new Blob([res]));
  let link = document.createElement("a");
  link.style.display = "none";
  link.href = urlLink;
  link.setAttribute("download", `${name}.xlsx`);
  document.body.appendChild(link);
  link.click();
}
